import React from 'react';
import useSetExport from '@components/export/useSetExport';
import { useSelector } from 'react-redux';
import { chartIntervalSelector } from '@store/trends/birdChart/selectors';
import { buildIntervalText } from '@components/export/parsers';


function useSetImpactedViewersExport({ columns, rows }) {

  const interval = useSelector(chartIntervalSelector);
  const headers = columns.map( ({ title, key }) => ({ title, key }));

  useSetExport({
    pageKey: 'trends',
    sectionKey: 'dimensions-panel',
    widgetKey: 'impacted-viewers',
    widgetInfo: {
      title: `Impacted Viewers (${buildIntervalText(interval)})`
    },
    data: rows,
    headers,
  });

}

export default useSetImpactedViewersExport;
